<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 2C11.3137 2 14 4.59366 14 7.79311C14 9.44984 13.2797 10.9441 12.125 12L9.5 9.60346" stroke="black" stroke-width="1.5"/>
    <path d="M8 14C4.68629 14 2 11.4063 2 8.20689C2 6.55016 2.72029 5.05586 3.875 4L6.5 6.39654" stroke="black" stroke-width="1.5"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconLaterality'
}
</script>
